<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
  <div data-testId="propsForm">
    <div *ngFor="let statementKey of question.statementsOrder let i = index;">
      <img
        *ngIf="surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang) && question.useImage"
        src="{{surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang)}}"
        alt="image" [style.width]="question.imageSize+'px'"
        class="image-label">
      <mat-form-field class="props-input-container" data-testId="props" appearance="outline">
        <mat-label>
          {{question.statements[statementKey].label | translateLabel: activeLang}}
        </mat-label>
        <input [errorStateMatcher]="errorMatcher" matInput type="number" min="0"
               [formControl]="$any(questionFormControl.get(statementKey))"
               (blur)="questionFormControl.get(statementKey).setValue($event.target.value[0] === '-' ? 0 : $event.target.value)">
        <span matSuffix class="props-input-suffix">{{question.numericalValuesUnity}}</span>
        <mat-error>
          {{errorMessage[statementKey]|transloco}}.
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
